module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAt0lEQVR4Ae3QgQaDUBSH8U8EQMSwB9kABTE90gUXAWwPMOwZeoReIgjDnmKCuzkYOaLjguV+f9zo9kPEl6LG46mJzhMI+F1ACUpQRkehoIKODEM5PYGRcgGVjAR6cjZ3ZpbPJw4/6MgkT29Oln/RIBRP7nI+eMk506j7a9CCWk4YK6QpYcyQooQxQ4oSxgwpSphYCC7fEQ9J/w05eTHgN26Q+w5VS8C+FnQ3M3NlpQqH3zhHRcrUB96V7qPncoR0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/load.png
// module id = 411
// module chunks = 0